import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-list-analytic-user',
  templateUrl: './list-analytic-user.component.html',
  styleUrls: ['./list-analytic-user.component.scss']
})
export class ListAnalyticUserComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
